import { useEffect, useState } from 'react'
import { off, onValue, ref } from 'firebase/database'
import { auth, db } from '../firebase'

import { get } from 'lodash'

const usePostUserScore = ({ isQuick = false, postId }) => {
  const uid = get(auth, 'currentUser.uid')
  const refPath = isQuick ? `quickVotes/${postId}/${uid}/score` : `votes/${postId}/${uid}/score`

  const [score, setScore] = useState()
  const [loading, setLoading] = useState(true)

  let postScoreRef

  useEffect(() => {
    const get = () => {
      postScoreRef = ref(db, refPath)
      onValue(postScoreRef, (item) => {
        if (item.val()) {
          setScore(item.val())
        }
        setLoading(false)
      })
    }
    get()

    return () => {
      if (postScoreRef) { // close the connection
        off(postScoreRef)
      }
    }
  }, [postId])

  return {
    score,
    loading
  }
}

export default usePostUserScore
